import React, { Component } from 'react';
import {getBreadCrumbsList, removeBreadCrumbsItem} from '../../modules/Api';
import ReactTable from 'react-table';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import { END_POINT } from '../../constants/config';
import ACL from '../../components/ACL';
class BreadCrumbs extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getBreadCrumbsList(query, (res) => {this.setState({
            items: res.data.data,
            last_page: res.data.last_page,
            count: res.data.total,
            pageSize: res.data.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;
        this.fetchData(query);
    }

    removeBanner(id) {
        const warningMessage = `آیا از حذف برید کرامبز اطمینان کامل دارید ؟ `;
        if (window.confirm(warningMessage)) {
            removeBreadCrumbsItem(id, () => {
                notification.open({
                    message: `برید کرامبز با موفقیت حذف شد!`,
                    description: ``
                })
            });
            this.fetchData();
        }
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                // filterable: true,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: true,
                Cell: (row) => (<ACL component="div" ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.title} onClick={() => {window.open(`/bread-crumbs/edit/${row.original.id}`, "_blank")}}> {row.original.title} </span></ACL>)
            },
            {
                Header: 'لینک هدف',
                accessor: 'link',
                filterable: true,
                Cell: (row) => (<ACL component="div" ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.link} > {row.original.link} </span></ACL>)

            },
            {
                Header: 'اولویت',
                accessor: 'order',
                filterable: true,
                Cell: (row) => (<ACL component="div" ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.order} > {row.original.order} </span></ACL>)

            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                // sortable: false,
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="coupons_management|coupons_delete"><span onClick={() => {this.removeBanner(row.original.id)}}  style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                    </React.Fragment>
                )
            },

        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div className="btn-container">
                    <ACL component="div" has_permission="coupons_management|coupons_add"><Button type="primary" onClick={() => history.item.push(`/bread-crumbs/add`)}>افزودن برید کرامبز جدید</Button></ACL>
                </div>

                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default BreadCrumbs;



// WEBPACK FOOTER //
// ./src/containers/BreadCrumbs/index.js